<template>
  <el-container class="body_container">
    <el-row class="head_line">系统日志</el-row>
    <el-header class="header-title" style="height: 70px">
      <el-form v-model="searchAccessVo" :inline="true" class="search_select" style="margin-top: 10px">
        <el-row>
          <el-form-item prop="" >
            <el-select v-model="searchAccessVo.type" placeholder="请选择"  @change="change" size="small" style="width: 100px">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="" >
            <el-select v-model="searchAccessVo.types" placeholder="请选择"  @change="roleChange" size="small" style="width: 100px">
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item  label-width="125px">
            <!--<el-date-picker style="width: 128px"-->
                            <!--v-model="searchAccessVo.startTime"-->
                            <!--format="yyyy-MM-dd"-->
                            <!--placeholder="选择日期"-->
                            <!--type="date">-->
            <!--</el-date-picker>-->
            <!-- - -->
            <!--<el-date-picker style="width: 128px;"-->
                            <!--v-model="searchAccessVo.endTime"-->
                            <!--placeholder="选择日期"-->
                            <!--format="yyyy-MM-dd"-->
                            <!--type="date">-->
            <!--</el-date-picker>-->
            <el-date-picker
              v-model="value1"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item class="dialog-footer">
            <el-button class="clearDate" @click="resetForm">重置</el-button>
            <el-button  @click="search" type="primary">查询</el-button>
          </el-form-item>
        </el-row>
      </el-form>
    </el-header>
    <el-main class="search_result emp_search_result">
      <el-table :data="logs.list">
        <el-table-column prop="logIp"  label="IP地址" width="220px"  >
          <template slot-scope="scope">
            <el-link type="primary" @click="loadLog(scope.row)">{{scope.row.logIp}}</el-link>
            <!--<button @click="loadLog(scope.row)" type="text">{{scope.row.logIp}}</button>-->
          </template>
        </el-table-column>
        <el-table-column prop="userName"  label="用户名称"  width="180px" ></el-table-column>
        <el-table-column prop="logTime"  label="日期时间" width="250px"></el-table-column>
        <!--<el-table-column prop="logIp"  label="IP地址" width="100px"></el-table-column>-->
        <el-table-column prop="logAction"  label="操作" width="220px"></el-table-column>
        <!--<el-table-column :show-overflow-tooltip="true" prop="logMethod"  label="方法" width="140px"></el-table-column>-->
        <!--<el-table-column :show-overflow-tooltip="true" prop="logUrl"  label="地址" width="140px"></el-table-column>-->
        <!--<el-table-column :show-overflow-tooltip="true"  prop="logParams"  label="参数" width="140px"></el-table-column>-->
        <el-table-column prop="result" :formatter="formatterColumn" label="结果" ></el-table-column>
        <!--<el-table-column :show-overflow-tooltip="true" prop="reason"    label="消息" width="100px"></el-table-column>-->
        <!--<el-table-column :show-overflow-tooltip="true"  prop="types"  label="类型" width="100px"></el-table-column>-->
        <el-table-column prop="id" label="查看详情">
          <template slot-scope="scope">
            <!--<el-button size="mini" @click="checkQuote(scope.row)">-->
            &nbsp;
            <i class="el-icon-more" @click="loadLog(scope.row)" style="font-size: 16px;color: #666;cursor: pointer"></i>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-dialog title="日志详情" :append-to-body="true" :visible.sync="logVisible" width="700px" :modal="true" :close-on-click-modal="false" :close-on-press-escape="false">
      <template>
      <el-form size="mini" >
        <el-row type="flex" >
          <el-col>
            <el-form-item label="用户名称:" label-width="90px">
              {{logAccess.userName}}
            </el-form-item>
            <el-form-item label="日志时间:" label-width="90px">
              {{logAccess.logTime }}
            </el-form-item>
            <el-form-item label="IP地址:" label-width="90px">
              {{logAccess.logIp}}
            </el-form-item>
            <el-form-item label="操作:" label-width="90px">
              {{logAccess.logAction}}
            </el-form-item>
            <el-form-item label="方法:" label-width="90px">
              {{logAccess.logMethod}}
            </el-form-item>
            <el-form-item label="地址:" label-width="90px">
              {{logAccess.logUrl}}
            </el-form-item>
            <el-form-item label="参数:" label-width="90px">
              {{logAccess.logParams}}
            </el-form-item>
            <!--<el-form-item label="结果">-->
              <!--{{logAccess.result}}-->
            <!--</el-form-item>-->
            <el-form-item label="结果:" label-width="90px" v-if="logAccess.result===null || logAccess.result===''"></el-form-item>
            <el-form-item label="结果:" label-width="90px" v-if="logAccess.result==0">正常</el-form-item>
            <el-form-item label="结果:"  label-width="90px" v-if="logAccess.result==1">无权限</el-form-item>
            <el-form-item label="结果:" label-width="90px" v-if="logAccess.result==2">报错</el-form-item>
            <el-form-item label="原因:" label-width="90px">
              {{logAccess.reason}}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      </template>
    </el-dialog>
    <el-pagination class="page"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   layout="prev, pager, next, jumper"
                   :page-size="logs.rows"
                   :current-page="logs.page"
                   :total="logs.total">
    </el-pagination>
  </el-container>
</template>

<script>
import log from '@/api/log'
export default {
  name: 'Access',
  data () {
    return {
      logVisible: false,
      value1: [],
      filters: {
        name: ''
      },
      logs: {
        page: 1,
        rows: 10,
        total: 0,
        list: []
      },
      dateValue: '',
      searchAccessVo: {
        type: '1',
        types: '0',
        startTime: '',
        endTime: '',
        page: 1,
        rows: 15
      },
      logAccess: {
        id: null,
        userId: null,
        userName: '',
        logTime: '',
        logIp: '',
        logAction: '',
        logMethod: '',
        logUrl: '',
        logParams: '',
        result: '',
        reason: ''
      }
    }
  },
  computed: {
    options () {
      return [
        {
          value: '1',
          label: '当月'
        },
        {
          value: '0',
          label: '所有'
        }
      ]
    },
    typeOptions () {
      return [
        {
          value: '1',
          label: '用户'
        },
        {
          value: '0',
          label: '律师'
        }
      ]
    },
    // result0: function () {
    //   return this.$t('access.result0')
    // },
    // result1: function () {
    //   return this.$t('access.result1')
    // },
    // result2: function () {
    //   return this.$t('access.result2')
    // }
  },
  methods: {
    reload () {
      this.searchAccessVo.startTime = this.value1[0]
      this.searchAccessVo.endTime = this.value1[1]
      // console.log(this.searchAccessVo)
      log.find(this.searchAccessVo).then(res => {
        if (res.data.code === 0) {
          // console.log(res.data.data)
          this.logs = res.data.data
        }else {
          this.logs = {
              page: 1,
              rows: 10,
              total: 0,
              list: []
          }
        }
      })
    },
    // 重置form
    resetForm () {
      this.value1 = []
      this.searchAccessVo = {
        type: '1',
        types: '0',
        startTime: '',
        endTime: '',
        page: 1,
        rows: 15
      }
      this.reload()
    },
    formatterColumn (row, column) {
      return row.result === '0' ? '正常' : row.result === '1' ? '无权限' : row.result === '2' ? '报错' : ''
    },
    search () {
      this.searchAccessVo.page = 1
      this.reload()
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange (val) {
      this.searchAccessVo.page = val
      this.reload()
    },
    loadLog (row) {
      log.load({id: row.id, type: this.searchAccessVo.type}).then(res => {
        this.logAccess = res.data.data
      })
      this.logVisible = true
    },
    change (val) {
      this.searchAccessVo.page = 1
      this.searchAccessVo.type = val
      this.reload()
    },
    roleChange (val) {
      this.searchAccessVo.page = 1
      this.searchAccessVo.types = val
      this.reload()
    }
  },
  created () {
    this.reload()
  }
}
</script>
<style>
  .el-tooltip__popper{font-size: 14px; max-width:50% }
</style>



// WEBPACK FOOTER //
// src/components/log/SysLog.vue